import Image from "next/image";
import parse from "html-react-parser";
import React from "react";

const InstructionCardMobile = ({ ...props }) => (
	<>
		<div className={`instruction-card instruction-card-${props.id}`}>
			<div className="instruction-card-img-container">
				<Image
					src={props.img}
					layout="fill"
					objectFit="contain"
					alt={props.content}
					quality={100}
				/>
			</div>
			<p className="instruction-card-content">{parse(props.content)}</p>
		</div>

		<style jsx>
			{`
				.instruction-card {
          width: 100%;
          text-align: center;
        }
        
				.instruction-card-img-container {
					width: 200px;
          height: 250px;
          margin: auto;
					position: relative;
        }

				.instruction-card-img {
					width: auto;
					height: auto;
				}

        .instruction-card-content {
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: #13161A;
          margin-top: 34px;
        }

        .instruction-card + .instruction-card {
          margin-top: 24px;
        }
			`}
		</style>
	</>

);

export default InstructionCardMobile;
